<div *transloco="let t" formGroupName="about">

  <app-string-field
    formControlName="name"
    [maxLength]="255"
    [label]="'Quel nom d\'organisateur devons-nous afficher?'">
  </app-string-field>

  <app-choice-radio-field
    formControlName="legalForm"
    [choices]="legalFormChoices"
    [label]="'Quel type d\'organisateur est ' + aboutForm().controls.name.value + '?'"
    [optional]="true">
  </app-choice-radio-field>

  <app-text-field
    formControlName="description"
    [maxLength]="1000"
    [label]="'Description'"
    [description]="'Décris ton organisation avec tes mots...'"
    [optional]="true">
  </app-text-field>

<!--  <app-activity-media-field-->
<!--    [activity]="activity()"-->
<!--    [label]="'Illustre ton activité avec une image'"-->
<!--    [optional]="true"-->
<!--    formControlName="picture">-->
<!--  </app-activity-media-field>-->
</div>
